module.exports = __webpack_public_path__ + "img/figure-17.b32bd48c.png";